import { Component, Input } from '@angular/core';
import { ProviderWithZone } from '../../services/user.service';

@Component({
  selector: 'app-profile-box[userName]',
  templateUrl: 'profile-box.component.html',
  styles: [
    `
      :host {
        display: block;
        padding: 0 theme('padding.3');
      }

      .profile-box__info-container {
        text-align: center;
        font-size: theme('fontSize.sm');

        > p {
          margin: theme('margin.2');
        }
      }
    `,
  ],
})
export class ProfileBoxComponent {
  @Input() public userName!: string;
  @Input() public provider!: ProviderWithZone | null;
}
